<template>
  <button class="">
    <slot />
  </button>
</template>

<script>
export default {
  props: ["type"],
};
</script>

<style scoped>
button {
  text-decoration: underline;
}
</style>
